import React from 'react'
import { Grid, Typography } from '@the-platform-group/component-library'

// PageHeader component from irwin-fe
// This is legacy PageHeader component from irwin-fe, in future it may be phased out and replaced with a new PageHeader component
// TODO: eventually deprecate this in favor of PageHeader component in index.jsx
// and move new PageHeader in index.jsx to this file
/**
 * Layout component for rendering a title with subnav
 * @param {object} props - component props
 * @param {string} props.title - page title
 * @param {string} props.subtitle - page subtitle displayed below the title
 * @param {React.Component} props.subNav - subnav component
 * @param {React.Component} props.children - children components to display after the title
 * @returns {React.Component} component
 */
function PageHeader({ title, subtitle, subNav, children, item = false }) {
  return (
    <Grid container justifyContent="space-between" alignItems="stretch">
      <Grid container alignItems="center" item sx={{ width: 'initial' }} columnSpacing={2}>
        <Grid item>
          <Typography
            component="h1"
            variant="h5"
            sx={{ whiteSpace: 'nowrap' }}
            gutterBottom={Boolean(subtitle)}
          >
            {title}
          </Typography>
        </Grid>
        {children}
      </Grid>
      <Grid container item justifyContent="flex-end" sx={{ width: 'initial', mb: -2 }}>
        {subNav}
      </Grid>
      {subtitle && (
        <Grid item xs={12}>
          <Typography>{subtitle}</Typography>
        </Grid>
      )}
    </Grid>
  )
}

export default PageHeader
